import { Injectable } from '@angular/core';
import * as AWS from 'aws-sdk';
import { AnyNaptrRecord } from 'dns';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})


export class VoicemailService {
  public keyPrefix: any
  public bucket: any
 
  
  constructor() {
  this.bucket = environment.audioS3BucketDomain.split('/')[0]; 
  this.keyPrefix = environment.audioS3BucketDomain.split('/')[1] }

  userNameSearch(username){
    let lambda = new AWS.Lambda({ region: environment.region });
    let lambdaParams = {
      FunctionName: environment.userSearchLambdaName,
      Payload: JSON.stringify({
        username: username
      })
    };
    return this.buildPromise(lambda, lambdaParams);
  }

  generatePollyVoice(content){
    let lambda = new AWS.Lambda({ region: environment.region });
    let lambdaParams = {
      FunctionName: environment.pollyVoiceLambdaName,
      Payload: JSON.stringify({
        operation: "create",
        content: content
      })
    };
    return this.buildPromise(lambda, lambdaParams);
  }

  generateKey(greetingId, username){
      console.log("THIS IS THE KEY", `${this.keyPrefix}${username}/${greetingId}.wav`)
     return(`${this.keyPrefix}/${username}/${greetingId}.wav`)
     
  }

  generateContent(keyS3){
    console.log('GENERATE CONTENT', this.bucket + '/' + keyS3 )
     return(this.bucket + '/' + keyS3)
  }

  getUserDataEnabled(userName){
    let lambda = new AWS.Lambda({ region: environment.region });
    let lambdaParams = {
      FunctionName: environment.connectUserLambda,
      Payload: JSON.stringify({
        username: userName,
        operation: "get",
        dataPath: "Voicemail.personalVoicemailGreeting.greetingId"
        
      })
    };
    return this.buildPromise(lambda, lambdaParams);
    
  }
  deleteUserGreetings(greetingId){
    let lambda = new AWS.Lambda({ region: environment.region });
    let lambdaParams = {
      FunctionName: environment.userGreetingsLambdaName,
      Payload: JSON.stringify({
        operation: "delete",
        greetingId: greetingId
      })
    };
    return this.buildPromise(lambda, lambdaParams);
  }

  enableUserGreetings(username, greetingId){
    let lambda = new AWS.Lambda({ region: environment.region });
    let lambdaParams = {
      FunctionName: environment.userGreetingsLambdaName,
      Payload: JSON.stringify({
        operation: "enable",
        username: username,
        greetingId: greetingId
      })
    };
    return this.buildPromise(lambda, lambdaParams);
  }

  putUserGreetings(username, greetingId, type, content, description){
    let lambda = new AWS.Lambda({ region: environment.region });
    let lambdaParams = {
      FunctionName: environment.userGreetingsLambdaName,
      Payload: JSON.stringify({
        operation: "put",
        greeting: {
          username: username,
          greetingId: greetingId,
          type: type,
          content: content,
          description: description
        }
        
      })
    };
    return this.buildPromise(lambda, lambdaParams);
  }

  getUserGreetings(username){
    let lambda = new AWS.Lambda({ region: environment.region });
    let lambdaParams = {
      FunctionName: environment.userGreetingsLambdaName,
      Payload: JSON.stringify({
        operation: "get",
        username: username
      })
    };
    return this.buildPromise(lambda, lambdaParams);
  }

  getAgentVoicemailConfig(userName){
    let lambda = new AWS.Lambda({ region: environment.region });
    let lambdaParams = {
      FunctionName: environment.connectUserLambda,
      Payload: JSON.stringify({
        username: userName,
        operation: "get",
        dataPath: "Voicemail"
        
      })
    };
    return this.buildPromise(lambda, lambdaParams);
    
  }

  putAgentVoicemailConfig(userName, vmConfig){
    let lambda = new AWS.Lambda({ region: environment.region });
    let lambdaParams = {
      FunctionName: environment.connectUserLambda,
      Payload: JSON.stringify({
        username: userName,
        operation: "put",
        voicemailConfig: vmConfig
        
      })
    };
    return this.buildPromise(lambda, lambdaParams);
  }
 
  storeWav(blob, key, bucket){
    return new Promise<AnyNaptrRecord>((resolve, reject) =>{
      let lambda = new AWS.Lambda({ region: environment.region });
      let lambdaParams = {
        FunctionName: environment.genPresignedUrlLambdaName,
        Payload: JSON.stringify({
          operation: "put",
          bucket: bucket,
          key: key,
          args: {
            ContentType: "audio/wav"
          }
        })
      };
      this.buildPromise(lambda, lambdaParams).then(
        (response:any) => {
          console.log("store wav response: ", response);
          console.info("Attempting file upload. contents: ", blob);
          fetch(response.url, {method: "PUT", body: blob, headers: {'Content-Type': 'audio/wav'}}).then((response:any) =>{
            console.log("Presigned url PUT response: ", response);
            resolve(response);
          });
        },
        err =>{
          console.error(err);
          reject(err);
        }
      );
    });
  }

  getWav(bucket, keyS3){
    let lambda = new AWS.Lambda({ region: environment.region });
    let lambdaParams = {
      FunctionName: environment.genPresignedUrlLambdaName,
      Payload: JSON.stringify({
        operation: "get",
        bucket: bucket,
        key: keyS3
      })
    };
    return this.buildPromise(lambda, lambdaParams);
  }

  buildPromise(lambda, params) {
    return new Promise((resolve, reject) => {
      lambda.invoke(params, (err, data) => {
        if (err) {
          reject(err);
        } else {
          try {
            let response = (data as any);
            let payload = JSON.parse(response.Payload);
            resolve(payload);
          } catch(e) {
            console.error(e);
            console.error(`failed to parse response: `, data);
            reject(data);
          }
        }
      });
    });
  }
}
